// One contingent's workspace, Overview (tkt/ContingentsRoutes.jsx). A contingent belongs to one event, named
// by ?event=; without it the module asks the backend which event, so a shared link opens it cold.
import React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { contingentsEnabled } from '../lib/accessGating';
import { ContingentWorkspaceRoute } from '../modules/venue-port/tkt/ContingentsRoutes';

export const Route = createFileRoute('/contingents/$contingentId/')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: () => {
    if (!contingentsEnabled()) throw redirect({ to: '/', replace: true });
  },
  component: () => <ContingentWorkspaceRoute tab="overview" />,
});
